<template>
  <div class="purse-body">
    <div class="Content-subject">
      <div class="content-box" v-html="dataCom.content"></div>
    </div>
  </div>
</template>

<script>
import {
  getSysAboutPageUsByCode, // 根据code获取关于我们下对应页面信息
} from "../../../assets/api/JobInterview";
export default {
  data() {
    return {
      dataCom: {},
    };
  },
  components: {},
  //
  created() {
    this.getSysAboutPageUsByCode();
  },
  methods: {
    // -----------------------根据code获取关于我们下对应页面信息-------------
    async getSysAboutPageUsByCode() {
      var data = {
        data: {
          code: "ZJY003",
        },
      };
      const res = await getSysAboutPageUsByCode(data);
      this.dataCom = res.data;
    },
  },
};
</script>

<style scoped lang="less">
// 最外层div
.purse-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  // 内容主体
  .Content-subject {
    width: 100%;
    flex: 1;
    min-height: 0;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 5px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .content-box {
      flex: 1;
      min-height: 0;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 30px;
      box-sizing: border-box;
      word-break: break-word;
      overflow-wrap: break-word;
    }
    /deep/.content-box p {
      font-size: 14px;
      letter-spacing: 1.5px;
      line-height: 30px;
      font-weight: 400;
      text-indent: 30px;
    }
    /deep/.content-box img {
      max-width: 100%;
      width: auto;
      height: auto;
      max-height: 400px;
      margin: 0 auto !important;
      display: block;
    }
    /deep/.content-box table {
      max-width: 100%;
      overflow-x: auto;
      display: block;
    }
  }
}
</style>
